import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { getAllCategories, getAllProducts } from '../data/catalog';
import { isProductVisible, useAvailabilityTick } from '../utils/availability';
import { useCatalogTick } from '../utils/customProducts';

export default function CategoriesPage() {
  useAvailabilityTick();
  useCatalogTick();
  const products = getAllProducts();
  const categories = [...getAllCategories()].sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'));
  const countFor = (slug) => products.filter((p) => p.categorySlug === slug && isProductVisible(p)).length;

  return (
    <main className="mx-auto max-w-7xl px-4 py-8 md:py-12" data-testid="categories-page">
      <nav className="text-xs text-muted-foreground" aria-label="Breadcrumb">
        Início / <span className="text-foreground">Categorias</span>
      </nav>
      <h1 className="mt-3 font-serif text-3xl tracking-tight text-navy md:text-4xl" data-testid="categories-title">
        Todas as Categorias
      </h1>
      <p className="mt-2 max-w-xl text-sm text-muted-foreground md:text-base">
        Explore nosso acervo por categoria e encontre o tecido ideal para o seu projeto.
      </p>

      <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4" data-testid="categories-grid">
        {categories.map((c) => {
          const count = countFor(c.slug);
          return (
            <Link
              key={c.slug}
              to={`/categoria/${c.slug}`}
              data-testid={`categories-card-${c.slug}`}
              className="group relative overflow-hidden rounded-2xl bg-navy-light"
            >
              {c.image ? (
                <img
                  src={c.image}
                  alt={`Categoria ${c.name}`}
                  loading="lazy"
                  className="aspect-[4/3] w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              ) : (
                <div
                  className="flex aspect-[4/3] w-full items-center justify-center"
                  data-testid={`categories-card-no-image-${c.slug}`}
                >
                  <span className="font-serif text-5xl text-navy/25">{c.name.charAt(0)}</span>
                </div>
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/85 via-navy-dark/15 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4 text-white">
                <p className="font-serif text-lg leading-tight">{c.name}</p>
                {c.tagline ? <p className="mt-0.5 text-xs text-white/80">{c.tagline}</p> : null}
                <p
                  className="mt-1.5 flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide text-white/90"
                  data-testid={`categories-card-count-${c.slug}`}
                >
                  {count} {count === 1 ? 'tecido' : 'tecidos'} <ArrowRight className="h-3 w-3" />
                </p>
              </div>
            </Link>
          );
        })}
      </div>
    </main>
  );
}
